import React from 'react';
import styled from 'styled-components';
import _get from 'lodash.get';
import Checkbox from '@ntuctech/devex-tangram/Checkbox';
import Typography from '@ntuctech/devex-tangram/Typography';
import { useFeatureFlag } from '../../FeatureFlagProvider';
import { FLAGS } from '../../../constants';

import { useAuth0 } from '../../Auth0Provider';

export const ConsentCheckbox = styled(Checkbox)`
  height: auto !important;
  align-items: flex-start;
  padding-top: 0.125rem;
  padding-left: 0.125rem;

  & ._ndsCheck__styled {
    min-width: 1.25rem;
    margin-right: 0.375rem !important;
  }
  & p {
    margin-top: -0.0625rem;
    margin-left: 0.0625rem;
    font-size: 0.75rem;
    line-height: 1rem;
    color: #4d4d4d !important;
  }
`;

export const GroupConsent = () => {
  const { userContext } = useAuth0();
  const { isTreatmentOn } = useFeatureFlag();
  const isDecoupleLuckyDrawEnabled = isTreatmentOn(FLAGS.DECOUPLE_LUCKY_DRAW);

  const marketingConsent = React.useMemo(() => {
    return _get(userContext, 'clientBasedUi.marketingConsent', '');
  }, [userContext]);

  let parsedMarketingConsent = '';
  if (isDecoupleLuckyDrawEnabled && marketingConsent.includes('lucky draws from FairPrice Group')) {
    parsedMarketingConsent = `Get $10 OFF my first online grocery order! 
    Send me Linkpoints and exclusive offers from FairPrice Group, 
    its business partners and agents via email, text messages and phone calls.`;
  } else {
    parsedMarketingConsent = marketingConsent;
  }

  return (
    <Typography variant="body3" data-testid="SignUpConsentText">
      {parsedMarketingConsent}
    </Typography>
  );
};
